import {useEffect, useState} from 'react';
import {t, useLocale} from '../localization/adminText';
import {waitForPolaris} from '../utils/polarisRuntime';
import PageLoading from './PageLoading';
import {loadShopifyBridge} from '../utils/shopifyBridge';

export default function PolarisWebBoundary({children}) {
  useLocale();
  const [state, setState] = useState('loading');
  useEffect(() => {
    let active = true;
    // Keep the existing token/context flow. Embedded page chrome needs its existing App Bridge.
    const bridge = window.self !== window.top ? loadShopifyBridge() : Promise.resolve();
    Promise.all([bridge, waitForPolaris()]).then(() => {
      if (active) setState('ready');
    }).catch(() => { if (active) setState('error'); });
    return () => { active = false; };
  }, []);
  if (state === 'ready') return children;
  if (state === 'error') return <div role="alert" style={{padding: 24}}>
    <p>{t('Unable to load Shopify components. Reload the app.')}</p>
    <button type="button" onClick={() => window.location.reload()}>{t('Retry')}</button>
  </div>;
  return <PageLoading label="Loading page"/>;
}
